import { render, staticRenderFns } from "./FantasyMapPlayer.vue?vue&type=template&id=0bcae9d4&scoped=true&"
import script from "./FantasyMapPlayer.vue?vue&type=script&lang=js&"
export * from "./FantasyMapPlayer.vue?vue&type=script&lang=js&"
import style0 from "./FantasyMapPlayer.vue?vue&type=style&index=0&id=0bcae9d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcae9d4",
  null
  
)

export default component.exports